export default {
  header: 'Neue Bestellungen pausiert',
  text: 'Zur Widerherstellung irgendwo tippen',
};
